import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import Header from 'Components/ComponentLibrary/Molecules/Header';


const styles = (theme) => ({
  root: {
  },
  field: {
    marginTop: theme.spacing(4),
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const { onSubmit } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { resource } = useMetaLayoutContext();

  return (
    <Box className={classNames(classes.root, className)}>
      <Header
        title={resource.attr('title')}
      />
      <BodyText text={`${resource.attr('primaryText')}`} />
      <MetaControlField className={classes.field} attr={'phoneNumber'} />
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Sms: submit phone number');
            onSubmit();
          }}
          test={'security-settings-button-sms-register-modal-send-code'}
        >
          {'Send Code'}
        </RoundedButton>
      </CenteredActions>
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
